import React, { useState } from 'react'
import { PatientHistoryType } from 'src/graphql.generated'
import { UploadedPatientFile } from '../../../../api/useUploadPatientFile'
import { useSubmitPatientHistory } from '../../../../api/useSubmitPatientHistory'
import {
  FieldGrid,
  FieldSection,
  FormActions,
  LabeledDate,
  LabeledText,
  todayIso,
  useRequiredFields,
} from '../../../fieldPrimitives'
import { ADVANCED_NOTE_KIND_FIELD, INTAKE_NOTE_NUTRITION } from '../advancedNoteKinds'
import FileUploadField from '../FileUploadField'
import IntakeTrackSelect from '../IntakeTrackSelect'

// A Note, not an IntakeNote: billing reads the latest IntakeNote's billing codes, and this one has none.
const IntakeNoteNutritionFields = ({ uid }: { uid: string }) => {
  const [date, setDate] = useState(todayIso())
  const [trackKey, setTrackKey] = useState('')
  const [description, setDescription] = useState('')
  const [files, setFiles] = useState<UploadedPatientFile[]>([])
  const { submit, submitting, error } = useSubmitPatientHistory(uid)

  const required = useRequiredFields({
    'Date of event': Boolean(date),
    'Nutrition intake notes': Boolean(description.trim()),
  })

  const onSubmit = async () => {
    if (!required.attempt()) {
      return
    }

    await submit({
      date,
      type: PatientHistoryType.Note,
      value: {
        description,
        [ADVANCED_NOTE_KIND_FIELD]: INTAKE_NOTE_NUTRITION,
        ...(trackKey ? { trackKey } : null),
      },
      fileIDs: files.map((file) => file.fileID),
    })
    setDescription('')
    setFiles([])
    required.reset()
  }

  return (
    <FieldSection>
      <FieldGrid>
        <LabeledDate
          label="Date of event"
          value={date}
          onChange={setDate}
          required
          error={required.error('Date of event')}
        />
      </FieldGrid>
      <IntakeTrackSelect value={trackKey} onChange={setTrackKey} />
      <LabeledText
        label="Nutrition intake notes"
        value={description}
        onChange={setDescription}
        multiline
        required
        error={required.error('Nutrition intake notes')}
      />
      <FileUploadField uid={uid} files={files} onChange={setFiles} />
      <FormActions onSubmit={onSubmit} disabled={false} submitting={submitting} error={error} />
    </FieldSection>
  )
}

export default IntakeNoteNutritionFields
